module.exports = __webpack_public_path__ + "pcid/img/fatherandmother.59bdf095.png";